import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageAdministrationComponent } from './component/message-administration.component';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';

import { ApplicationClientCommonModule } from '@sdbn/appclient';

import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    MessageAdministrationComponent
  ]

})
export class MessageAdministrationModule { }

